const menu = {
    label: 'Parâmetros',
    icon: 'pi pi-fw pi-cog',
    to: '/rm/parametros',
    rules: ['CONVENIOS-PARAMETROS-00'],
};

export default menu;
